export default "__VITE_ASSET__t9OpcUmD__"